// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Rniu","content":"styles_content__20bjU","title":"styles_title__36y1A"};